// extracted by mini-css-extract-plugin
export default {"topportion_htag":"CompanyReview_topportion_htag__d1CW2","topportion_div":"CompanyReview_topportion_div__GR1Jd"};